// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"235":"square","592":"collect"}[chunkId] + "." + {"235":"be83ddc2","592":"75de1c2a"}[chunkId] + ".css";
};